import { useEffect, useRef } from 'react';
import { useQueryClient } from 'react-query';
import { getStreamByEndpointAsync } from 'services/Events';
import { getLiveAttendanceStreamEndpoint } from 'services/SchoolClass';
import { ILiveAttendanceTriggerPayload } from 'services/SchoolClass/types';
import { SCHOOL_CLASS_KEYS } from '../useQuery';

interface UseLiveAttendanceSocketProps {
  classId?: number | null;
}

export const useLiveAttendanceSocket = ({ classId }: UseLiveAttendanceSocketProps) => {
  const queryClient = useQueryClient();
  const isFirstMessage = useRef(true);

  useEffect(() => {
    if (!classId) return;

    let isActive = true;
    isFirstMessage.current = true;
    let socketConnection: WebSocket | null = null;

    const fetchData = async () => {
      const endpoint = getLiveAttendanceStreamEndpoint(classId);

      const connection = await getStreamByEndpointAsync(
        endpoint,
        (payload: ILiveAttendanceTriggerPayload) => {
          if (!isActive) return;

          if (isFirstMessage.current) {
            isFirstMessage.current = false;
            return; 
          }

          console.log(`⚡ Catraca girou na Turma ${classId}! Aluno: ${payload?.name || 'Desconhecido'}`);
          
          queryClient.invalidateQueries([
            SCHOOL_CLASS_KEYS.ALL,
            SCHOOL_CLASS_KEYS.LIVE_ATTENDANCE, 
            classId
          ]);
        },
        { pageNumber: 1, pageSize: 1 }, 
        () => {}, 
        () => {}, 
        { isPaused: false } as any, 
        true
      );

      if (!isActive) {
        if (connection) {
          (connection as any)._isIntentionalClose = true;
          connection.close();
        }
        return;
      }

      socketConnection = connection;
    };

    fetchData();

    return () => {
      isActive = false;
      if (socketConnection) {
        (socketConnection as any)._isIntentionalClose = true; 
        socketConnection.close();
      }
    };
  }, [classId, queryClient]);
};